module.exports = __webpack_public_path__ + "media/promo/hochland/images/v4-7352eadbacfd72d8e3f31f6f5f79475f.png";